import { render, staticRenderFns } from "./riHeader.vue?vue&type=template&id=43f5c193&"
import script from "./riHeader.vue?vue&type=script&lang=js&"
export * from "./riHeader.vue?vue&type=script&lang=js&"
import style0 from "./riHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports